"use client";
import React, { useEffect, useRef } from "react";
import Image from "next/image";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function CICDAnimation() {
  const cicdref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (cicdref.current) {
      const CICDImg =
        cicdref.current.querySelectorAll<HTMLImageElement>(".cicd");

      const tl = gsap.timeline({ defaults: { ease: "power3.inOut" } });

      tl.fromTo(
        CICDImg,
        { opacity: 0 },
        { opacity: 1, duration: 0.8, ease: "slow(0.6, 0.6, false)" }
      );

      ScrollTrigger.create({
        trigger: cicdref.current,
        start: "top 60%",
        end: "bottom 10%",
        animation: tl,

        onEnter: () => {
          tl.play();
          reloadGif(CICDImg);
        },
      });
    }
  }, []);

  const reloadGif = (gifElements: NodeListOf<HTMLImageElement>) => {
    gifElements.forEach(element => {
      const src = element.src;
      element.src = "";
      setTimeout(() => {
        element.src = src;
      }, 0);
    });
  };

  return (
    <div ref={cicdref} className='items-center w-full'>
      <Image
        width={1128}
        height={784}
        src={"/images/ci-cd.webp"}
        className='w-full max-w-[1280px] h-auto mx-auto'
        alt={"Qualitia Boson"}
      />
    </div>
  );
}
